import React, { PureComponent } from 'react';
import Alert from '../../Alert';

export default class BorderedAlertsWithIcons extends PureComponent {
  render () {
    return (
      <Alert color={this.props.level} alertButton={this.props.alertButton} className='alert--bordered' onAlertClose={this.props.onAlertClose} icon>
        <p style={{ fontSize: "14px" }}><span className='bold-text'>{`${this.props.alertTag}!`}</span> {this.props.msg}</p>
      </Alert>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/alerts/components/BorderedAlertsWithIcons.js